import { z } from 'zod'

/** Every API error uses this shape: `{ error: { code, message, details? } }`. */
export const ErrorCode = z.enum([
  'validation_failed',
  'unauthenticated',
  'forbidden',
  'not_found',
  'conflict',
  'rate_limited',
  'payload_too_large',
  /** Over a plan limit (bikes, storage). The message says what to do. */
  'plan_limit',
  /** A feature that is switched off on this server. */
  'unavailable',
  'internal',
])
export type ErrorCode = z.infer<typeof ErrorCode>

export const ApiError = z.object({
  error: z.object({
    code: ErrorCode,
    message: z.string(),
    details: z.unknown().optional(),
  }),
})
export type ApiError = z.infer<typeof ApiError>

export const httpStatusForCode: Record<ErrorCode, number> = {
  validation_failed: 400,
  unauthenticated: 401,
  forbidden: 403,
  not_found: 404,
  conflict: 409,
  payload_too_large: 413,
  plan_limit: 402,
  unavailable: 503,
  rate_limited: 429,
  internal: 500,
}

export function isApiError(value: unknown): value is ApiError {
  return ApiError.safeParse(value).success
}
